var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceApIs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2929 15.0698L27.3214 15.2905L27.4409 15.4782L31.0866 21.2109L28.0014 22.5325L27.3952 22.7922V23.4517V28.3334C27.3952 29.6221 26.3506 30.6667 25.0618 30.6667H21.7302H20.7305L20.7302 31.6664L20.7288 35.6667H7.72858L7.72893 30.5103C7.72908 28.2799 6.90013 26.2039 5.43449 24.3763C3.74092 22.2643 2.72852 19.5851 2.72852 16.6667C2.72852 9.85519 8.25033 4.33337 15.0618 4.33337C21.3318 4.33337 26.5103 9.01303 27.2929 15.0698ZM31.1917 21.3762C31.1917 21.3761 31.1917 21.3761 31.1916 21.3761L31.1917 21.3762Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3174 30.1706C37.2615 27.2603 38.3949 23.7626 38.3949 20.0001C38.3949 16.2375 37.2615 12.7397 35.3174 9.82947",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceApIs);
export default __webpack_public_path__ + "static/media/voiceAPIs.34f6e72ecd1f0ddc6ac1bf235fe9fbd2.svg";
export { ForwardRef as ReactComponent };